import { render, staticRenderFns } from "./DataInsertModal.vue?vue&type=template&id=dc384484&"
import script from "./DataInsertModal.vue?vue&type=script&lang=ts&"
export * from "./DataInsertModal.vue?vue&type=script&lang=ts&"
import style0 from "./DataInsertModal.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports